export function HorizontalDivider() {
  return (
    <hr className="h-px w-full border-0 bg-slate-900 md:max-w-sm mx-auto" />
  );
}
